import React, { useState } from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage } from '@divvy-web/i18n'
import Icon from '@divvy-web/skylab.icon'
import TextLink from '@divvy-web/skylab.textlink'

import InviteCollaboratorsDrawer from '@sputnik/components/InviteCollaborators/InviteCollaboratorsDrawer'
import useApplicationCollaborators from '@sputnik/hooks/useApplicationCollaborators'
import { useWebTracking } from '@sputnik/tracking/WebTrackingContext'

import styles from './styles.module.scss'

export interface InviteCollaboratorsButtonProps {
  appId: string
}

const InviteCollaboratorsLink = ({ appId }: InviteCollaboratorsButtonProps) => {
  const [getClassName] = useNameFormatter('InviteCollaboratorsButton')
  const [isInviteCollaborShowing, setIsInviteCollaboratorShowing] = useState(false)
  const { tracker } = useWebTracking()

  const { allCollaborators } = useApplicationCollaborators({ salesforceCreditId: appId })

  return (
    <div className={styles[getClassName('')]}>
      <TextLink
        isDark
        onClick={() => {
          tracker?.track('se_signup__left_nav_invite_collaborator__fired')
          setIsInviteCollaboratorShowing(true)
        }}
      >
        <Icon
          className={styles[getClassName('icon')]}
          name='send'
        />
        {allCollaborators.length > 0 ? (
          <FormattedMessage
            defaultMessage='Manage collaborators'
            id='sputnik.InviteCollaboratorsLink__ewiWwP'
          />
        ) : (
          <FormattedMessage
            defaultMessage='Invite collaborators'
            id='sputnik.InviteCollaboratorsLink__ni18Y2'
          />
        )}
      </TextLink>
      <InviteCollaboratorsDrawer
        appId={appId ?? ''}
        isShowing={isInviteCollaborShowing}
        onClose={() => setIsInviteCollaboratorShowing(false)}
      />
    </div>
  )
}

export default InviteCollaboratorsLink
